var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTongyongGongju(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 5a.5.5 0 01.5-.5h11a.5.5 0 01.5.5v8a.5.5 0 01-.5.5h-11A.5.5 0 012 13V5z",
    stroke: "#3F465C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 8h4.5M14 8H9.5",
    stroke: "#3F465C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 4V2.75a.25.25 0 00-.25-.25h-5.5a.25.25 0 00-.25.25V4",
    stroke: "#3F465C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#3F465C",
    strokeLinejoin: "round",
    d: "M7 6.5h2v3H7z"
  })));
}
export default __webpack_public_path__ + "static/tongyong_gongju.2b82bf5e.svg";
export { SvgTongyongGongju as ReactComponent };